module.exports = __webpack_public_path__ + "assets/img/line2.44d6b19e.png";